var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"mylist"}},_vm._l((_vm.images),function(image){return _c('div',{key:image.id,staticClass:"mediaItem",attrs:{"data-photo-id":image.id}},[_c('MediaItem',{attrs:{"image":image,"client-width":_vm.clientWidth}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }